/**
 * Action for listing reservations.
 *
 * @class
 */
var scrollTimer, changeTimer, isPagebrowserLoading;
Sitepackage.Plugin.Reservation.ListAction = (function () {
    /**
     * Initializes the action.
     *
     * @param {Reservation} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var ListAction = function (plugin, pluginContainer, container) {
        const self = this;

        // Parent plugin
        self.plugin = plugin;

        // Parent plugin container
        self.pluginContainer = pluginContainer;

        // Main container of the action
        self.container = container;

        //Replace cHash from url in data attribute to prevent 404 errors when JS adds parameters
        self.container.dataset.url = self.container.dataset.url.replace(/[\?&]cHash=[^&]+/, '');

        //Page browser / Infinite Scroll
        self.showAllButton = self.container.querySelector('[data-action="show-all"]');

        self.initializeDatePickers();

        self.debitorSelect = self.container.querySelector('.debitor-select');

        if (self.debitorSelect) {
            self.debitorSelect.querySelectorAll('.dropdown-item').forEach(function (item) {
                item.addEventListener('click', function (event) {
                    self.setActiveDebitor(event.target);
                    self.applyFilter();
                    return false;
                });
            });
        }

        if (self.showAllButton) {
            self.showAllButton.addEventListener("click", function (e) {
                if (self.showAllButton.classList.contains("active")) {
                    self.removeAllRecords();
                    self.updateCountInfo();
                    self.loadNewPage(0);
                    self.showAllButton.classList.remove('active');
                    self.container.dataset.showall = 0;
                } else if (self.container.dataset.shown !== self.container.dataset.total && !self.showAllButton.classList.contains("active")) {
                    self.loadAllRecords();
                    self.showAllButton.classList.add('active');
                    self.container.dataset.showall = 1;
                }
                e.preventDefault();
                e.stopPropagation();
                return false;
            });

            if ((self.container.dataset.showall === "true" || self.container.dataset.showall == 1) && parseInt(self.container.dataset.shown) < parseInt(self.container.dataset.total)) {
                self.loadAllRecords();
            }
        }

        if (self.debitorSelect) {
            var activeDebitor = self.debitorSelect.querySelector('.dropdown-item.active');
            if (!activeDebitor) {
                activeDebitor = self.debitorSelect.querySelector('.dropdown-item:first-child');
            }
            self.setActiveDebitor(activeDebitor);
        }

        self.houseSelect = self.container.querySelector('.house-select');

        self.houseSelect.querySelectorAll('.dropdown-item').forEach(function (item) {
            item.addEventListener('click', function (event) {
                self.setActiveHouse(event.target);
                self.applyFilter();
                return false;
            });
        });

        var activeHouse = self.houseSelect.querySelector('.dropdown-item.active');
        if (!activeHouse) {
            activeHouse = self.houseSelect.querySelector('.dropdown-item:first-child');
        }
        self.setActiveHouse(activeHouse);

        self.updateCountInfo();

        self.initializeEvents();

        GeneralUtility.initializeDropdownSearch();


        window.addEventListener("scroll", function () {
            if (scrollTimer) {
                window.clearTimeout(scrollTimer);
            }
            scrollTimer = window.setTimeout(function () {
                if (!isPagebrowserLoading && self.container.dataset.hasnextpage && GeneralUtility.isElementInViewport(document.getElementById('footer'), 500)) {
                    self.loadNewPage(parseInt(self.container.dataset.currentpage) + 1);
                }
            }, 200);
        }, false);
    };

    /**
     *
     */
    ListAction.prototype.initializeDatePickers = function () {
        const self = this;
        var dateFilter = document.getElementById('date-filter');

        var datepickerLanguage = 'de';
        if (parseInt(Globals.languageId) === 1) {
            datepickerLanguage = 'en';
        }

        const today = new Date();
        const minDate = new Date(today.getFullYear() - 10, today.getMonth(), today.getDate());
        const maxDate = new Date(today.getFullYear() + 2, today.getMonth(), today.getDate());
        var dateRangePickerInstance = new DateRangePicker(dateFilter, {
            autohide: true,

            language: datepickerLanguage,
            buttonClass: 'btn',
            defaultViewDate: today,
            allowOneSidedRange: true,
            minDate: minDate,
            maxDate: maxDate,

            format: Globals.dateFormat,

            prevArrow: Globals.iconPrevious,
            nextArrow: Globals.iconNext,

            beforeShowDay: function (date) {


                return {
                    enabled: true,
                    content: '<span class="day-cell-content">' + date.getDate() + '</span>'
                };
            },


            inputs: [
                document.getElementById('show-date-from'),
                document.getElementById('show-date-to')
            ]
        });

        var dateInput = document.getElementById('show-date-from');

        dateInput.addEventListener('focus', function (event) {
            this.parentElement.classList.add('focus');
        });
        dateInput.addEventListener('blur', function (event) {
            this.parentElement.classList.remove('focus');
        });
        dateInput.addEventListener('changeDate', function (event) {
            if (changeTimer) {
                window.clearTimeout(changeTimer);
            }
            changeTimer = window.setTimeout(function () {
                self.applyFilter();
            }, 200);

        });

        dateInput = document.getElementById('show-date-to');

        dateInput.addEventListener('focus', function (event) {
            this.parentElement.classList.add('focus');
        });
        dateInput.addEventListener('blur', function (event) {
            this.parentElement.classList.remove('focus');
        });
        dateInput.addEventListener('changeDate', function (event) {
            if (changeTimer) {
                window.clearTimeout(changeTimer);
            }
            changeTimer = window.setTimeout(function () {
                self.applyFilter();
            }, 200);

        });

        GeneralUtility.addDatepickerCloseButton(dateRangePickerInstance.datepickers);


    };


    /**
     * Add event listeners
     *
     * @returns {void}
     */
    ListAction.prototype.initializeEvents = function () {
        const self = this;
        var openReservationNewModal = function (event) {
            document.getElementById('modal-reservation').querySelector('.modal-body').dataset.reservationid = '';
            document.getElementById('btn-new-reservation').Modal.show();
        };
        var openReservationEditModal = function (event) {

            var reservationId = event.target.closest('.booking-item').dataset.uid;
            if (reservationId) {
                document.getElementById('modal-reservation').querySelector('.modal-body').dataset.reservationid = reservationId;
                document.getElementById('btn-new-reservation').Modal.show();
                //document.getElementById('btn-new-reservation').click();
            }

        };
        var openReservationCodeModal = function (event) {

            var reservationId = event.target.closest('.booking-item').dataset.uid;

            if (reservationId) {
                document.getElementById('modal-reservation-code').querySelector('.modal-body').dataset.reservationid = reservationId;

            }

        };

        if (document.getElementById('btn-new-reservation')) {
            document.getElementById('btn-new-reservation').removeEventListener('click', openReservationNewModal);
            document.getElementById('btn-new-reservation').addEventListener('click', openReservationNewModal);
        }

        if (document.getElementById('btn-new-reservation-list')) {
            document.getElementById('btn-new-reservation-list').removeEventListener('click', openReservationNewModal);
            document.getElementById('btn-new-reservation-list').addEventListener('click', openReservationNewModal);
        }

        var resetHouseButton = document.getElementById('btn-reset-house');
        if (resetHouseButton) {
            var reloadWithoutHouse = function (event) {
                self.container.querySelector('[data-field="house"]').value = 0;
                self.applyFilter();
            };
            resetHouseButton.removeEventListener('click', reloadWithoutHouse);
            resetHouseButton.addEventListener('click', reloadWithoutHouse);
        }
        var resetSearchButton = document.getElementById('btn-reset-search');
        if (resetSearchButton) {
            var reloadWithoutSearch = function (event) {
                self.container.querySelector('[data-field="search"]').value = '';
                self.applyFilter();
            };
            resetSearchButton.removeEventListener('click', reloadWithoutSearch);
            resetSearchButton.addEventListener('click', reloadWithoutSearch);
        }
        self.container.querySelectorAll('.booking-item .cardbg a').forEach(function (item) {
            item.removeEventListener('click', openReservationEditModal);
            item.addEventListener('click', openReservationEditModal);
        });
        self.container.querySelectorAll('.booking-item .btn-code').forEach(function (item) {
            item.removeEventListener('click', openReservationCodeModal);
            item.addEventListener('click', openReservationCodeModal);
        });

        self.container.querySelectorAll('.booking-item').forEach(function (item) {
            item.removeEventListener('mouseover', function (e) {
                self.highlightSameReservation(item.dataset.uid);
            });
            item.addEventListener('mouseover', function (e) {
                self.highlightSameReservation(item.dataset.uid);
            });
            item.removeEventListener('mouseout', function (e) {
                self.unHighlightSameReservation(item.dataset.uid);
            });
            item.addEventListener('mouseout', function (e) {
                self.unHighlightSameReservation(item.dataset.uid);
            });
        });

    };

    /**
     * Adds hover class on reservation items with same reservation ID
     *
     * @returns {void}
     */
    ListAction.prototype.highlightSameReservation = function (reservationId) {
        const self = this;
        self.container.querySelectorAll('.booking-item[data-uid="' + reservationId + '"]').forEach(function (item) {
            item.querySelector('.cardbg').classList.add('hover');
        });
    };

    /**
     * Removes hover class on reservation items with same reservation ID
     *
     * @returns {void}
     */
    ListAction.prototype.unHighlightSameReservation = function (reservationId) {
        const self = this;
        self.container.querySelectorAll('.booking-item[data-uid="' + reservationId + '"]').forEach(function (item) {
            item.querySelector('.cardbg').classList.remove('hover');
        });
    };

    /**
     * Removes all pages
     *
     * @returns {void}
     */
    ListAction.prototype.removeAllRecords = function () {
        const self = this;
        self.container.querySelector('.booking-list').innerHTML = '';
    };

    /**
     * Loads new pages until all records are shown
     *
     * @returns {void}
     */
    ListAction.prototype.loadAllRecords = function () {
        const self = this;
        self.showAllButton.dataset.originalText = self.showAllButton.innerHTML;
        self.showAllButton.innerHTML = 'loading ...';
        if (self.container.dataset.hasnextpage) {
            self.loadNewPage(parseInt(self.container.dataset.currentpage) + 1);
        }

        self.plugin.listener['newPageLoaded'].push(function () {
            if (self.container.dataset.showall === "true" || self.container.dataset.showall == 1) {
                if (parseInt(self.container.dataset.shown) < parseInt(self.container.dataset.total) && self.container.dataset.hasnextpage) {
                    self.loadNewPage(parseInt(self.container.dataset.currentpage) + 1);
                } else {
                    self.showAllButton.innerHTML = self.showAllButton.dataset.originalText;
                }
            }
        });
    };

    /**
     * Loads a new page of items
     *
     * @returns {void}
     */
    ListAction.prototype.loadNewPage = function (page) {
        if (!isPagebrowserLoading) {
            const self = this;
            var url = self.container.dataset.url;
            isPagebrowserLoading = true;

            page = parseInt(page);
            if (isNaN(page)) {
                page = 0;
            }
            url = GeneralUtility.appendUrlParameter(url, 'p', page);
            url = GeneralUtility.appendUrlParameter(url, 'type', '6012');

            GeneralUtility.ajaxGetRequest(url, function (data) {
                if (data) {

                    var dataElement = document.createElement('temp');
                    dataElement.innerHTML = data;

                    /*
                        Select last date and first new date and move reservations to existing date if date equals
                        This prevents multiple headers with the same day being shown
                     */
                    var existingDateGroups = self.container.querySelectorAll('.booking-dategroup');
                    if (existingDateGroups) {
                        var lastExisting = existingDateGroups[existingDateGroups.length - 1];
                        var newDateGroups = dataElement.querySelectorAll('.booking-dategroup');
                        var firstNew = newDateGroups[0];


                        if (lastExisting && firstNew && lastExisting.dataset.date === firstNew.dataset.date) {
                            var itemsToMove = firstNew.querySelectorAll('.booking-item');
                            var docFrag = document.createDocumentFragment();
                            var itemsCount = itemsToMove.length
                            for (var i = 0; i < itemsCount; i++) {
                                docFrag.appendChild(itemsToMove[i]); // Note that this does NOT go to the DOM
                            }
                            lastExisting.append(docFrag);
                            firstNew.remove();
                        }
                    }

                    var docFrag = document.createDocumentFragment();
                    var items = dataElement.querySelectorAll('.booking-dategroup');
                    var itemsCount = items.length
                    for (var i = 0; i < itemsCount; i++) {
                        docFrag.appendChild(items[i]); // Note that this does NOT go to the DOM
                    }
                    self.container.querySelector('.booking-list').append(docFrag);
                    self.updateCountInfo();
                    self.initializeEvents();
                    self.container.dataset.currentpage = page;
                    self.container.dataset.hasnextpage = dataElement.querySelector('.new-items-content').dataset.hasnextpage;
                    isPagebrowserLoading = false;
                    self.plugin.dispatchEvent('newPageLoaded', []);
                }

            });
        }
    };

    /**
     * Updates info of currently shown reservations
     *
     * @returns {void}
     */
    ListAction.prototype.updateCountInfo = function () {
        var itemsShown = this.container.querySelectorAll('.booking-item').length;
        var totalItems = parseInt(this.container.dataset.total);
        if (itemsShown !== totalItems) {
            document.getElementById('shown-count').innerHTML = itemsShown + ' / ';
        } else {
            document.getElementById('shown-count').innerHTML = '';
        }
        this.container.dataset.shown = itemsShown;
    };

    /**
     * Sets the active location in filter dropdown
     *
     * @returns {void}
     */
    ListAction.prototype.setActiveDebitor = function (activeElement) {
        var allItems = this.debitorSelect.querySelectorAll('.dropdown-item');
        allItems.forEach(function (item) {
            item.classList.remove('active');
        });

        if (activeElement) {
            activeElement.classList.add('active');


            this.debitorSelect.dataset.selected = activeElement.dataset.id;
            var html = activeElement.dataset.name;
            if (parseInt(activeElement.dataset.id) > 0) {
                html = '<span class="d-none d-md-inline">' + activeElement.dataset.name + '(' + activeElement.dataset.id + ')<span><span class="d-inline d-md-none">' + activeElement.dataset.id + '</span>';
            }
            this.debitorSelect.querySelector('.dropdown-label').innerHTML = html;
            this.container.querySelector('[data-field="debitor"]').value = activeElement.dataset.id;
        }
    };

    /**
     * Sets the active house in filter dropdown
     *
     * @returns {void}
     */
    ListAction.prototype.setActiveHouse = function (activeElement) {
        var allItems = this.houseSelect.querySelectorAll('.dropdown-item');
        allItems.forEach(function (item) {
            item.classList.remove('active');
        });
        if (activeElement) {

            activeElement.classList.add('active');

            this.houseSelect.dataset.selected = activeElement.dataset.id;
            var html = activeElement.dataset.name;
            this.houseSelect.querySelector('.dropdown-label').innerHTML = html;
            this.container.querySelector('[data-field="house"]').value = activeElement.dataset.id;
        }
    };

    /**
     * Applies all filters.
     *
     * @returns {void}
     */
    ListAction.prototype.applyFilter = function () {
        var selectedFromDate = document.getElementById('show-date-from').value;
        this.container.querySelector('[data-datefield="from"]').value = selectedFromDate;

        var selectedToDate = document.getElementById('show-date-to').value;
        this.container.querySelector('[data-datefield="to"]').value = selectedToDate;
        document.getElementById('search-filter').submit();
    };

    return ListAction;
})();
